import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import LoginPage from './pages/LoginPage'
import DashboardLayout from './components/layouts/DashboardLayout'
import DashboardPage from './pages/DashboardPage'
import ModerationPage from './pages/ModerationPage'
import TripsPage from './pages/TripsPage'
import TripDetailPage from './pages/TripDetailPage'
import EventsPage from './pages/EventsPage'
import PostsPage from './pages/PostsPage'
import UsersPage from './pages/UsersPage'
import AdminsPage from './pages/AdminsPage'
import AuditLogPage from './pages/AuditLogPage'
import SearchPage from './pages/SearchPage'
import SettingsPage from './pages/SettingsPage'
import ExplorePage from './pages/ExplorePage'
import { UserProtectedRoute } from './components/routes/UserProtectedRoute'
import { UserLayout } from './components/layouts/UserLayout'
import UserHomePage from './pages/user/UserHomePage'
import UserProfilePage from './pages/user/UserProfilePage'
import UserTripsPage from './pages/user/UserTripsPage'
import UserPostsPage from './pages/user/UserPostsPage'
import UserEventsPage from './pages/user/UserEventsPage'
import UserExplorePage from './pages/user/UserExplorePage'
import UserTripDetailPage from './pages/user/UserTripDetailPage'
import UserPinPage from './pages/user/UserPinPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isHydrated } = useAuthStore()

  // Wait for store to hydrate from localStorage
  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          <p className="mt-2 text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route path="/" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<DashboardPage />} />
          <Route path="moderation" element={<ModerationPage />} />
          <Route path="trips" element={<TripsPage />} />
          <Route path="trips/:id" element={<TripDetailPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="posts" element={<PostsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="admins" element={<AdminsPage />} />
          <Route path="audit-log" element={<AuditLogPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="explore" element={<ExplorePage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route
          path="/user/pin"
          element={
            <UserProtectedRoute requirePin={false}>
              <UserPinPage />
            </UserProtectedRoute>
          }
        />

        <Route
          path="/user"
          element={
            <UserProtectedRoute>
              <UserLayout />
            </UserProtectedRoute>
          }
        >
          <Route index element={<UserHomePage />} />
          <Route path="posts" element={<UserPostsPage />} />
          <Route path="trips" element={<UserTripsPage />} />
          <Route path="trips/:id" element={<UserTripDetailPage />} />
          <Route path="events" element={<UserEventsPage />} />
          <Route path="explore" element={<UserExplorePage />} />
          <Route path="profile" element={<UserProfilePage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
